<template>
  <div class="purchase-cargo-insurance-certificate-detail">
    <span>{{ t('cargoInsurance.certificate.reviewPrompt') }}</span>
    <div
      class="mt-4 p-4 border-1 border-round border-200 flex flex-column gap-4"
    >
      <CargoInsuranceCertificateDetail
        :cargo-insurance-certificate="cargoInsuranceCertificate"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { CargoInsuranceCertificate } from '@/model/cargoInsurance';

import CargoInsuranceCertificateDetail from '@/components/cargoInsurance/CargoInsuranceCertificateDetail.vue';

const props = defineProps<{
  cargoInsuranceCertificate: CargoInsuranceCertificate;
}>();

const { cargoInsuranceCertificate } = toRefs(props);

const { t } = useI18n();
</script>
